import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';

function CreateMultiplePersonsModal(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    
    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [peopleInput, setPeopleInput] = useState("");

    function clearForm(){
        setPeopleInput("");
    }

    function handleCreatePerson() {
        axios.post(
            "/api/persons/list",
            {
                data: peopleInput
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onSaveNew != undefined) props.onSaveNew(res.data);
            notifySuccess(t("people.toast_people_created"));
            clearForm();
        });
    }

    function handleCreateEvents() {
        axios.post(
            "/api/events/addsGuestsInfo",
            {
                data: peopleInput,
                event: props.event
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onSaveNew != undefined) props.onSaveNew(res.data.createdGuestList);
            if (props.onBookingsChange != undefined) props.onBookingsChange(res.data.changedBookings);
            if (props.onCustomersChange != undefined) props.onCustomersChange([res.data.createdCustomer]);
            notifySuccess(t("people.toast_people_created"));
            clearForm();
        });
    }

    useEffect(() => {
        
    }, []);

    return (
        <Modal show={props.show} onHide={() => { if(props.onHide != undefined) props.onHide(); }} size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("people.multiplenew.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <p>{t("people.multiplenew.explaination")}</p> */}
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            {t("people.multiplenew.dataformat").split(",").map((title,key) => 
                                <td key={key} style={{
                                    border: "1px solid lightgray",
                                    padding: "4px 12px"
                                }}>{title}</td>
                            )}
                        </tr>
                    </tbody>
                </table>
                <hr />
                <Field
                    title={t("people.multiplenew.input_title")}
                    type="textarea"
                    value={peopleInput}
                    onChange={(val) => setPeopleInput(val)}
                ></Field>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); }}>
                    {t("people.cancel")}
                </Button>
                <Button onClick={props.event != undefined ? handleCreateEvents :handleCreatePerson}>
                    {t("people.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateMultiplePersonsModal;